<!-- Hidden state holder: file + preview live here, the dropzone below is the visual surface. -->
<app-upload-preview
  class="image-upload-field__hidden"
  #preview
  [previewTitle]="previewTitle"
  (onDelete)="onDelete()"
></app-upload-preview>

<div
  class="upload"
  *ngIf="!preview.previewUrl"
  (click)="upload.fileInput.nativeElement.click()"
>
  <mat-icon fontSet="material-icons-round">{{ icon }}</mat-icon>
  <strong>{{ title }}</strong>
  <span *ngIf="hint">{{ hint }}</span>
</div>

<div class="upload upload--filled" *ngIf="preview.previewUrl">
  <img
    class="upload__preview"
    [class.upload__preview--square]="square"
    [class.upload__preview--contain]="contain"
    [src]="preview.previewUrl"
    [alt]="alt"
  />
  <button type="button" class="upload__remove" (click)="preview.opetConfirmDeleteModal()">
    <mat-icon fontSet="material-icons-round">delete</mat-icon>
    {{ removeLabel || ('global.delete' | transloco) }}
  </button>
</div>

<app-upload
  #upload
  [required]="required"
  [showV2Error]="true"
  [label]="label"
  [placeholder]="placeholder"
  (onUpload)="onUpload($event)"
></app-upload>
